import { createSelector } from "@reduxjs/toolkit";

import { depotRoutesSorterSelector } from "../sorters/selectors";

export const routeManagementLoadingSelector = (state) =>
  state.routeManagement.loading;
export const isRemovingRouteSelector = (state) =>
  state.routeManagement.isRemovingRoute;

export const maxAdditionalMinutesSelector = (state) =>
  state.routeManagement.maxAdditionalMinutes;
export const routeConfigSelector = (state) => state.routeManagement.routeConfig;
export const routesSelector = (state) => state.routeManagement.routes;
export const routeSelector = (routeCode) => (state) =>
  state.routeManagement.routes.find((route) => route.routeCode === routeCode);

export const routeEditModeSelector = (state) =>
  !!state.routeManagement.routeEdit;
export const routeEditSelector = (state) => state.routeManagement.routeEdit;
export const routeEditCopySelector = (state) =>
  state.routeManagement.routeEditCopy;
export const isRouteEditValidSelector = (state) =>
  state.routeManagement.isRouteEditValid;

export const routeOptionsSelector = createSelector(routesSelector, (routes) => {
  if (!routes) return [];
  return routes.map(({ routeCode }) => ({
    value: routeCode,
    routeCode,
  }));
});

export const reorderedRoutesListSelector = createSelector(
  routesSelector,
  depotRoutesSorterSelector,
  (routes, sorter) =>
    [...(routes || [])].sort((a, b) => sorter({ route: a }, { route: b }))
);
